import { ISearchAddCashVoucherData } from '@lib/interfaces';

export function createSearchVoucherFilterUtil(filter: ISearchAddCashVoucherData): any {
  const result = { ...filter };
  delete(result.customerId);

  return result;
}
